import http from './index'

const initialise = async (data) => {
    return await http.post('/paycode/initialise', data)
}

export { initialise }
